/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import Label from "../../components/label";
import ICButton from "../../components/button";
import ICSelect from "../../components/form/selectInput";
import ICCheckbox from "../../components/form/checkbox";
import TableList from "../../containers/TicketsListTable";
import MakeAPICall from "../../apiCalls/common";
import { CSVLink } from "react-csv";
import { changeOptInStatusTicketSMSAPI } from "../../apiRoutes";
import { updateUserData } from "../../reduxStore/actions/auth";
import Loader from "../../components/loader";

class TicketPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      apiCall: null,
      apiLoading: false,
      ticketData: null,
      ticketStatus: [
        {
          id: 0,
          name: "Unopened",
          status: "OPEN"
        },
        {
          id: 1,
          name: "In Progress",
          status: "IN_PROGRESS"
        },
        {
          id: 2,
          name: "Support Action Required",
          status: "ADMIN_ACTION_REQUIRED"
        },
        {
          id: 3,
          name: "On Hold",
          status: "ON_HOLD"
        },
        {
          id: 4,
          name: "Resolved",
          status: "RESOLVED"
        },
        {
          id: 5,
          name: "All",
          status: "ALL"
        },
      ],
      selectedStatus: "",
      selectedStatusText: "",
      headers: [
        { label: "Ticket Number", key: "caseNumber" },
        { label: "Date Received", key: "dateReceived" },
        { label: "Doctor", key: "doctorName" },
        { label: "Doctor UIN", key: "doctorUIN" },
        { label: "Patient", key: "patientName" },
        { label: "Patient UIN", key: "patientUIN" },
        { label: "Subject", key: "subject" },
        { label: "Responsible", key: "responsible" },
        { label: "Status", key: "status" },
        { label: "Date Resolved", key: "dateResolved" }
      ],
      data: [
      ],
      isOptInForSMS: props.auth && props.auth.userData && props.auth.userData.optionalSettings && props.auth.userData.optionalSettings.isOptInForTicketSMS ? true : false,
    };
    this.csvInput = createRef();
  }


  componentAPICall = data => {
    this.setState({ apiCall: data });
  };

  getFiltertedTickets = (val) => {
    this.setState({
      selectedStatus: this.state.ticketStatus[val].status,
      selectedStatusText: this.state.ticketStatus[val].id
    });
  }

  downloadCSVFile = () => {    
    document.querySelector("#downloadCSV").click(); // pure js to get the click event + ref is not working with CSVLink element
  }

  handlUpdatedTicketData = (data) => {
    this.setState({
      data: data,
      ticketData: data
    });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleOptInForTicketSMS(event) {
    this.setState({
      apiLoading: true
    });

    const isChecked = event.target.checked;

    const dataToSend = {
      isOptInSMS: isChecked
    };

    let apiCallParam = {
      reqType: "POST",
      reqURL: changeOptInStatusTicketSMSAPI,
      dataObj: dataToSend,
      params: {},
      headers: {},
      successCallback: res => {
        console.log("Status updated: ", res, this.props);
        const doctorData = res.data.data;
        let stateUpdateData = {
          userData: doctorData,
          appConstant: this.props.auth.appConstant
        };
        this.props.updateUserData(stateUpdateData);
        this.setState({
          apiLoading: false,
          isOptInForSMS: doctorData.optionalSettings.isOptInForTicketSMS
        });
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        this.setState({
          apiLoading: false
        });
      },
    };
    this.componentAPICall(apiCallParam);
  }

  render() {
    return (
      <div className="row rounded p-3 ticket-page">
        {/* Top Filters */}
        <div className="col-sm-3 p-3">
          <Label title="Tickets" className="big" />
        </div>
        <div className="col-sm-4 pt-3 pr-0 text-right">
          <ICCheckbox
            name="Opt-In SMS Notifications"
            onChange={(e) => this.handleOptInForTicketSMS(e)}
            value={this.state.isOptInForSMS}
            inputProps={{ "aria-label": "opt-in-sms-ticket-notification" }}
            label="Opt-In SMS Notifications"
            className="ic-checkbox-font"
          />
        </div>
        <div className="col-sm-3 p-3">
          <ICSelect
            label=""
            useId="id"
            useValue="name"
            placeholder="Select Ticket Status"
            id="status"
            value={this.state.selectedStatusText !== "" ? this.state.selectedStatusText : "Select Ticket Status"}
            items={this.state.ticketStatus}
            handleChange={this.getFiltertedTickets}
          />
        </div>
        <div className="col-sm-2 pt-3">
          <ICButton title="Export To CSV" className="" clickEvent={this.downloadCSVFile} />
        </div>
        <div className="d-none p-3 text-right">
          {this.state.ticketData && this.state.ticketData.length ? 
          <CSVLink  id="downloadCSV" ref={this.csvInput} filename="Tickets.csv" className="d-none" data={this.state.ticketData} headers={this.state.headers}> Download me </CSVLink>
          : ''}
          
          {/* <ICButton title="Export To CSV" className="" clickEvent={this.downloadCSVFile} /> */}
        </div>
        <div className="col-sm-12 border-bottom"></div>

        <div className="col-sm-12 mt-5">
          <TableList makeAPICall={this.componentAPICall} statusFilter={this.state.selectedStatus} updateTicketData={this.handlUpdatedTicketData} />
        </div>
        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />

        {/* Loader */}
        <Loader loading={this.state.apiLoading} />
      </div>
    );
  }
}


// export default ProfileEditPage;
const mapStateToProps = state => ({
  auth: state.auth.user
});

const mapDispatchToProps = dispatch => ({
  updateUserData: (data) => dispatch(updateUserData(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketPage);
